import { useTranslation } from 'react-i18next'

import { IExcursionDetails } from 'shared/api/excursions/list/model'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

type Props = {
  currentExcursion: IExcursionDetails
}

export const StartDateInfo = ({ currentExcursion }: Props) => {
  const { t } = useTranslation()
  return (
    <Paper>
      <div className={s.startDateContainer}>
        <h5 className={s.startDateTitle}>{t('excursions.date_start')}</h5>
        <p className={s.startDate}>
          {dateFormat(
            currentExcursion.departure_date,
            DATE_FORMAT_LIST.DAY_MONTH_YEAR_WEEKDAY_SHORT,
          )}
        </p>
      </div>
    </Paper>
  )
}
